import { FETCH_DRUG_USAGE_DATA } from 'containers/DrugUsagePage/constants';
export const fetchDrugUsageData = (payload, params) => ({
  type: FETCH_DRUG_USAGE_DATA,
  payload,
  params,
});
